import { SCREENS } from "../../../routes/screens";
import Dropdown, { MenuItem } from "./Dropdown";

export const learnMoreLinks: MenuItem[] = [
  {
    label: "Engineers & Studios",
    link: {
      href: SCREENS.ADD_SUBSCRIPTION,
    },
    analytics: {
      label: "pricing_engineers_and_studios",
      data: { source: "pricing_dropdown" },
    },
  },
  {
    label: "Artists",
    link: {
      href: SCREENS.ADD_ARTIST_SUBSCRIPTION,
    },
    analytics: {
      label: "pricing_artists",
      data: { source: "pricing_dropdown" },
    },
  },
];

export const PricingDropdown = () => {
  return <Dropdown buttonText="Pricing" menuItems={learnMoreLinks} />;
};
